<template>
    <div>
        <b-card style="border: none; margin-left: 2rem; margin-right: 2rem">
            <b-row>
                <h5>Zusammenfassung</h5>
            </b-row>
            <b-row>
                <b-col md="6">
                    <label for="title">Aufgabe - Was ?</label>
                    <b-form-input
                            id="title" type="text"
                            :placeholder="was"
                            class="mb-2"
                            disabled
                            v-model="was"
                            style="text-overflow: ellipsis"
                    ></b-form-input>
                </b-col>
                <b-col md="3">
                    <label for="wo">Aufgabe - Wo ?</label>
                    <b-form-input id="wo" type="text"
                                  :placeholder="wo"
                                  class="mb-2"
                                  :disabled="!isInternal"
                                  v-model="wo"
                                  style="text-overflow: ellipsis"
                    ></b-form-input>
                </b-col>
                <b-col md="3">
                    <label for="wann">Aufgabe - Wann ?</label>
                    <b-form-input id="wann" type="text"
                                  :placeholder="wann"
                                  class="mb-2"
                                  disabled
                                  v-model="wann"
                                  style="text-overflow: ellipsis"
                    ></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label for="description">Aufgabe - Beschreibung</label>
                    <b-form-textarea
                            id="description"
                            class="text-black"
                            :placeholder="beschreibung"
                            rows="2"
                            max-rows="2"
                            wrap="hard"
                            disabled
                            v-model="beschreibung"
                    ></b-form-textarea>
                </b-col>
            </b-row>
          <b-row>
            <b-col md="6">
              <label class="mt-2" for="title">Empfänger</label>
              <b-form-input
                  id="title" type="text"
                  :placeholder="recipient"
                  disabled
                  v-model="recipient"
                  style="text-overflow: ellipsis"
              ></b-form-input>
            </b-col>
          </b-row>
            <b-row class="mt-2">
                <h5>Anhänge</h5>
            </b-row>
            <b-row v-if="data_id !== '' && anlagen !== ''">
                <b-col>
                    <p><b>Anhänge der Aufgabe: </b>
                        <a style="margin-left: 15px"
                           v-for="item in (anlagen === null ? '' : anlagen).split(';')"
                           v-if="item !== ''"
                           target="_blank"
                           v-on:click.prevent="showFile(url + '/auftragsbuch/upload/file/'+data_id+'?file_name='+encodeURIComponent(item)+'&file_type=A', item)"
                           :href="url + '/auftragsbuch/upload/file/'+data_id+'?file_name='+encodeURIComponent(item)+'&file_type=A'">
                            {{item}};
                        </a>
                    </p>
                </b-col>
            </b-row>
          <b-row v-if="message_files !== null && message_files.length">
            <b-col>
              <p><b>Anhänge aus dem Chat: </b>
                <a style="margin-left: 15px"
                   v-for="item in (message_files === null ? [] : message_files)"
                   v-if="item !== ''"
                   target="_blank"
                   v-on:click.prevent="showFile(url + '/auftragsbuch/'+encodeURIComponent(item), item.split('/')[item.split('/').length -1])"
                   :href="url + '/auftragsbuch/'+encodeURIComponent(item)">
                  {{item.split('/')[item.split('/').length -1]}};
                </a>
              </p>
            </b-col>
          </b-row>
            <b-row>
                <b-col md="12">
                    <span>Zum Einfügen in das Feld klicken</span>
                    <vue-dropzone v-on:vdropzone-error="log" ref="drop" id="drop" :options="dropOptions" style="max-height: 25vh; overflow: auto; padding: 8px"></vue-dropzone>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
    import vueDropzone from "vue2-dropzone";
    import {Server_URL} from "../../../shared/utils";
    import {arrayBufferToBase64, decryptFile} from "../../../shared/crypto";


    export default {
        name: "task_step4",
        components: {
            vueDropzone,
        },
        props: ['clickedNext', 'currentStep'],
        mounted() {
            this.$emit('can-continue', {value: true});
            this.was = this.currentStep.payload.was;
            this.wo = this.currentStep.payload.wo;
            this.wann = this.currentStep.payload.wann;
            this.beschreibung = this.currentStep.payload.beschreibung;
            this.anlagen = this.currentStep.payload.anlagen;
            this.message_files = this.currentStep.payload.message_files;
            this.data_id = this.currentStep.payload.data_id;
            this.isInternal = this.currentStep.payload.is_internal;
            this.recipient = this.currentStep.payload.recipient;
          this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
        },
        activated() {
          this.was = this.currentStep.payload.was;
          this.wo = this.currentStep.payload.wo;
          this.wann = this.currentStep.payload.wann;
          this.beschreibung = this.currentStep.payload.beschreibung;
          this.data_id = this.currentStep.payload.data_id;
          this.isInternal = this.currentStep.payload.is_internal;
          this.recipient = this.currentStep.payload.recipient;
          this.$emit('can-continue', {value: true});
          this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
        },
        data() {
            return {
              filename: "",
              isBauhof: false,
                was: "Test",
                wo: "Test",
                wann: "Test",
                beschreibung: "Test",
              recipient: "",
               dropOptions: {
                    url: "https://httpbin.org/post",
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    dictDefaultMessage: "<i class='icon-cloud-upload icon font-4xl mr-3 mt-3'></i>",
                    dictRemoveFile: "Entfernen",
                   maxFilesize: 5,
                    dictFileTooBig: "Die Datei ist zu groß ({{filesize}}MB). Maximale Dateigröße: {{maxFilesize}}MB",
                },
                anlagen: "",
                data_id: "",
                url: Server_URL,
                isInternal: false,
                message_files: [],
            }
        },

        methods: {
            setActive: function (payload) {
              this.isInternal = payload.is_internal;
              this.was = payload.was;
                this.wo = payload.wo;
                this.wann = payload.wann;
                this.beschreibung = payload.beschreibung;
                this.recipient = payload.recipient;
                if (this.$emit) {
                    this.$emit('can-continue', {value: true});
                }
            },
            getReturnData: function () {
                return {
                  files: this.$refs.drop.getQueuedFiles(),
                  wo: this.wo,
                };
            },
            log(file, message, xhr) {
                this.$refs.drop.removeFile(file);
                this.$bvToast.toast(message, {
                    title: 'Dateifehler',
                    autoHideDelay: 3000,
                    appendToast: false,
                    toaster: 'b-toaster-top-center',
                })
            },
            showFile(href, filename) {
                this.filename = filename;
                if (sessionStorage.getItem("aes") !== null) {
                    this.$http.get(
                        href, {responseType: 'blob'}
                    ).then(this.onFileOk, this.responseError)
                } else {
                    window.open(href, "_blank")
                }
            },
            onFileOk(response) {
                response.blob().then(blob => {
                    blob.arrayBuffer().then(binary => {
                        decryptFile(sessionStorage.getItem("aes"), new Uint8Array(binary)).then(res => {
                          if (this.isBauhof) {
                            try {
                              windowsFileService.onFile(
                                  arrayBufferToBase64(res),
                                  this.filename,
                                blob.type
                              ).then(r => {
                                if (r && !r.Success) {
                                  console.log(r)
                                }
                              }).catch(e => {
                                console.log(e)
                              });
                            } catch (e) {
                              console.log(e);
                            }
                            return
                          }
                          const b = new Blob([res], {type: blob.type});
                            const blobUrl = URL.createObjectURL(b);
                            window.open(blobUrl, '_blank');
                        }).catch(err => {
                          if (this.isBauhof) {
                            try {
                              windowsFileService.onFile(
                                  arrayBufferToBase64(binary),
                                this.filename,
                                blob.type
                              ).then(r => {
                                if (r && !r.Success) {
                                  console.log(r)
                                }
                              }).catch(e => {
                                console.log(e)
                              });
                            } catch (e) {
                              console.log(e);
                            }
                            return
                          }
                            const blobUrl = URL.createObjectURL(blob);
                            window.open(blobUrl, '_blank');
                        })
                    })
                });
            },
            responseError(response) {
                console.log(response)
            },
        }
    }
</script>

<style scoped>
    .form-control:disabled {
        color: black;
    }

    .text-black {
        color: black;
    }
</style>
